import { defineComponent as _defineComponent } from 'vue'
import {
  SigninTemplate,
  Heading,
  BaseText,
  ButtonPrimary,
  InputText
} from '@warrenbrasil/nebraska-web';
import {
  IRecaptcha,
  Recaptcha,
  RecaptchaActions
} from '@/modules/authentication/components/Recaptcha';
import { resetPassword } from '@/modules/common/services/http/account';
import {
  trackPageView,
  trackEmailEvent,
  trackRecoverButtonClickEvent,
  trackResetPasswordPageViewEvent
} from '../../helpers/track-reset-password-events';
import { LoginHero } from '@/modules/authentication/views/SignIn/components/LoginHero';
import { getEmailStepValidator } from '@/modules/authentication/views/SignIn/validate';
import { ref, computed, onMounted } from 'vue';
import { useRouter } from 'vue-router/composables';
import { useSigninStore } from '@/modules/authentication/store';


export default /*#__PURE__*/_defineComponent({
  __name: 'ResetView',
  setup(__props) {

const router = useRouter();
const signinModule = useSigninStore();

const inputEmail = ref('');
const statusType = ref('');
const submitDisabled = false;
const isLoading = ref(false);
const showError = ref(false);
const emailValidator = ref(getEmailStepValidator());
const recaptcha = ref(null);
const recaptchaToken = ref('');
const resetSuccess = ref(false);

onMounted(() => {
  trackPageView();
});

const backToSignin = () => {
  router.push({ name: 'signin' });
};

const inputChanged = async () => {
  showError.value = false;
  statusType.value = '';
};

function getError(field: string) {
  if (!showError.value) return '';
  statusType.value = 'error';
  return emailValidator.value.getError(field);
}

async function onSubmit() {
  trimEmail();
  await validate();

  if (!emailValidator.value.isValid()) {
    showError.value = true;
    return;
  }

  statusType.value = 'success';
  showError.value = false;

  trackRecoverButtonClickEvent();
  const recaptchaEl = recaptcha as unknown as IRecaptcha;

  if (recaptchaEl && recaptchaEl.onChallenge) {
    recaptchaEl.onChallenge(RecaptchaActions.RESET_PASSWORD);
  } else {
    doResetPassword();
  }
}

function handleBlur() {
  trackEmailEvent();
}

async function doResetPassword() {
  isLoading.value = true;
  try {
    await resetPassword({
      email: inputEmail.value,
      token: recaptchaToken.value
    });
    resetSuccess.value = true;
  } catch (e) {
    showError.value = true;
    resetRecaptcha();
    console.error('Erro ao resetar senha', e);
  } finally {
    isLoading.value = false;
    trackResetPasswordPageViewEvent();
  }
}

async function validate() {
  try {
    await emailValidator.value.validate({ email: inputEmail.value }, false);
  } catch {
    /* esse bloco precisa ficar vazio, porque o `YupValidation`
        da um throw por padrão quando erro de validação é encontrado */
  }
}

function resetRecaptcha() {
  const recaptchaEl = recaptcha as unknown as IRecaptcha;
  if (recaptchaEl) recaptchaEl.onReset();
}

function onRecaptchaToken(token: string) {
  recaptchaToken.value = token;
  doResetPassword();
}

function trimEmail() {
  inputEmail.value = inputEmail.value.trim();
}

const getLogo = computed(() =>
  !signinModule.isWarrenManaged ? signinModule.logo : ''
);

const getBrandName = computed(() =>
  !signinModule.isWarrenManaged && !getLogo ? signinModule.brandName : ''
);

return { __sfc: true,router, signinModule, inputEmail, statusType, submitDisabled, isLoading, showError, emailValidator, recaptcha, recaptchaToken, resetSuccess, backToSignin, inputChanged, getError, onSubmit, handleBlur, doResetPassword, validate, resetRecaptcha, onRecaptchaToken, trimEmail, getLogo, getBrandName, SigninTemplate, Heading, BaseText, ButtonPrimary, InputText, Recaptcha, LoginHero }
}

})